module.exports = __webpack_public_path__ + "static/media/sobre-background.842da053.jpg";